/**
 * App.tsx — Phase 4.I.1
 * Point d'entrée React — délègue tout le routage à AppRouter.
 * VF.1.SSL.J6 : Toaster sonner ajouté pour feedback export Excel/PPT.
 */
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { AppRouter } from '@/app/router';
import { Toaster } from 'sonner';

function App() {
  return (
    <ErrorBoundary>
      <AppRouter />
      <Toaster position="bottom-right" richColors closeButton />
    </ErrorBoundary>
  );
}

export default App;
